import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  doc,
  getDoc,
  getDocs,
  collection,
} from "firebase/firestore";
import { db } from "./firebase";

import ProductPage from "./ProductPage";
import ProductFamilyPage from "./ProductFamilyPage";
import Tradeshow from "./pages/tradeshows/Tradeshow";
import NotFound from "./pages/NotFound";

const makeSlug = (value = "") =>
  String(value)
    .trim()
    .toLowerCase()
    .replace(/&/g, "&")
    .replace(/\s+/g, "-");

function SlugRouter() {
  const { slug } = useParams();
  const [type, setType] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const checkSlug = async () => {
      setChecked(false);
      setType(null);

      try {
        // 1. Check product document ID first
        const productRef = doc(db, "products", slug);
        const productSnap = await getDoc(productRef);

        if (productSnap.exists()) {
          const productData = productSnap.data();

          const productName =
            productData.product ||
            productData.title ||
            slug;

          document.title =
            `${productName} | Go!Foton`;

          setType("product");
          setChecked(true);
          return;
        }

        // 2. Check tradeshow document ID
        const tradeshowRef = doc(db, "tradeshows", slug);
        const tradeshowSnap = await getDoc(tradeshowRef);

        if (tradeshowSnap.exists()) {
          const tradeshowData =
            tradeshowSnap.data();

          const tradeshowName =
            tradeshowData.name ||
            tradeshowData.title ||
            slug;

          document.title =
            `${tradeshowName} | Go!Foton`;

          setType("tradeshow");
          setChecked(true);
          return;
        }

        // 3. Check families from the products collection
        // This avoids guessing a separate productFamilies collection name.
        const productsSnap = await getDocs(collection(db, "products"));

        const familyMatch = productsSnap.docs.find((docSnap) => {
        const data = docSnap.data();

        const possibleFamilySlugs = [
          data.productFamilySlug,
          data.familySlug,
          data.productFamily,
        ]
          .filter(Boolean)
          .map(makeSlug);

        return possibleFamilySlugs.includes(slug);
      });

      if (familyMatch) {
        const familyData =
          familyMatch.data();

        const familyName =
          familyData.productFamily ||
          slug;

        document.title =
          `${familyName} | Fiber Optic Products | Go!Foton`;

        setType("family");
        setChecked(true);
        return;
      }

        document.title =
        "Page Not Found | Go!Foton";

      setType("not-found");
      setChecked(true);
      } catch (error) {
        console.error("SlugRouter error:", error);
        document.title =
          "Page Not Found | Go!Foton";

        setType("not-found");
        setChecked(true);
      }
    };

    checkSlug();
  }, [slug]);

  if (!checked) {
    return (
    <div className="loading-container">
          <div><center>
      <div className="spinner"></div>
      </center>
      </div>
    </div>
    );
  }

  if (type === "product") {
    return <ProductPage />;
  }

  if (type === "tradeshow") {
    return <Tradeshow />;
  }

  if (type === "family") {
    return <ProductFamilyPage />;
  }

  return <NotFound />;
}

export default SlugRouter;